import { z } from 'zod';

import { makeListQuery } from '../../common/list-query/list-query';
import { CAMPAIGN_NAME_MAX_LENGTH } from '../campaign/campaign';
import { CampaignStatusSchema } from '../campaign-status/campaign-status';

/**
 * The staff campaign list (N7).
 *
 * Offset-paginated like the delivery log — an admin table over data the reader
 * is not writing to. `search` matches the operator's own **name** for the
 * campaign, which is the one string they can quote from memory; the copy is not
 * searchable, because a campaign is found by what it was called, not by the
 * sentence a member read.
 */
export const CampaignsListQuerySchema = makeListQuery({
  status: CampaignStatusSchema.optional(),
  search: z.string().trim().min(1).max(CAMPAIGN_NAME_MAX_LENGTH).optional(),
});

export type CampaignsListQuery = z.infer<typeof CampaignsListQuerySchema>;
